import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import Loading from 'src/components/Loading';
import { renderRadioField } from 'src/jbc-front/components/Form';
import { INCOME_TAX_DECLARATION_FILE_FORMAT } from 'src/constants/Options';
import styles from './DownloadDeclarationModal.scss';

const DownloadDeclarationModal = ({ isOpen, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [fileFormat, setFileFormat] = useState('xml');
  const [isDownloading, setIsDownloading] = useState(false);

  const handleConfirm = async () => {
    setIsDownloading(true);
    try {
      await onConfirm(fileFormat);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <CommonModal isOpen={isOpen} hideModal={onCancel} ariaHideApp={false} className={styles['download-declaration-modal']}>
      <CommonModal.Header hideModal={onCancel}>{t('features.ReportIncomeTax.show.download_modal.title')}</CommonModal.Header>
      <CommonModal.Body>
        {renderRadioField({
          label: t('features.ReportIncomeTax.show.download_modal.select_format'),
          input: { name: 'fileFormat', value: fileFormat, onChange: e => setFileFormat(e.target.value) },
          options: INCOME_TAX_DECLARATION_FILE_FORMAT,
          meta: {}
        })}
        <p className="u-mt10">{t('features.ReportIncomeTax.show.download_modal.xml_note')}</p>
      </CommonModal.Body>
      <CommonModal.Footer>
        <CommonModal.Buttons>
          <Button onClick={onCancel} disabled={isDownloading}>
            {t('features.ReportIncomeTax.show.download_modal.cancel')}
          </Button>
          {isDownloading ? (
            <div className={styles.loading}>
              <Button primary disabled icon={<Loading />}>
                {t('features.ReportIncomeTax.show.download_modal.downloading')}
              </Button>
            </div>
          ) : (
            <Button onClick={handleConfirm} primary>
              {t('features.ReportIncomeTax.show.download_modal.continue')}
            </Button>
          )}
        </CommonModal.Buttons>
      </CommonModal.Footer>
    </CommonModal>
  );
};

DownloadDeclarationModal.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

DownloadDeclarationModal.defaultProps = {
  isOpen: false
};

export default DownloadDeclarationModal;
